import { FC, ReactNode } from 'react';
import classNames from 'classnames';

import getClassNames from '../../utils/getClassNames';
import Dropdown from '../Dropdown/index';
import Icon from '../Icon';
import style from './NavDropdown.module.scss';

type NavDropDownChildrenProps = {
  close: () => void;
};

type NavDropDownProps = {
  children: ReactNode | ((props: NavDropDownChildrenProps) => ReactNode);
  className: string;
  classNameModifier?: string;
  heading: ReactNode;
  shouldDropdownPersist?: boolean;
  'aria-label': string;
  'data-test': string;
  withChevron?: boolean;
};

const NavDropdown: FC<NavDropDownProps> = ({
  children,
  className,
  classNameModifier = '',
  heading,
  shouldDropdownPersist = false,
  'aria-label': ariaLabel,
  'data-test': dataTest,
  withChevron = true,
}) => (
  <Dropdown
    className={className}
    data-test={dataTest}
  >
    {({ toggle, isOpen, close }) => (
      <>
        <button
          type="button"
          onClick={toggle}
          className={getClassNames(style, 'button', classNames({ open: isOpen }))}
          aria-label={ariaLabel}
        >
          {heading}
          {withChevron && (
            <Icon
              id="nav/chevron"
              className={getClassNames(style, 'chevron', classNames({
                shouldPersistMediumAndUp: shouldDropdownPersist,
              }))}
            />
          )}
        </button>
        {isOpen && (
          <ul className={getClassNames(style, 'content', classNameModifier)}>
            {typeof children === 'function' ? children({ close }) : children}
          </ul>
        )}
      </>
    )}
  </Dropdown>
);

export default NavDropdown;
